import { SvgIconProps } from 'ui/icons/SvgIcon';

export const CampaignZeroState = ({ height = 128, width = 129, ...props }: SvgIconProps) => (
  <svg
    width={height}
    height={width}
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_9074_89)">
      <path
        d="M115.84 71.808C115.839 64.1676 114.129 56.6242 110.833 49.7309C107.538 42.8377 102.742 36.7693 96.7966 31.9706C90.8511 27.172 83.907 23.7649 76.4734 21.999C69.0399 20.2332 61.3054 20.1534 53.837 21.7655C46.3686 23.3776 39.3557 26.6407 33.3125 31.3156C27.2692 35.9905 22.3488 41.9586 18.9121 48.7824C15.4753 55.6063 13.6094 63.1127 13.451 70.7515C13.2926 78.3902 14.8459 85.9676 17.9968 92.928H111.283C114.293 86.2941 115.847 79.0926 115.84 71.808Z"
        fill="#F5F4F4"
      />
      <path
        d="M14.08 92.928H113.92"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.32001 92.928H11.52"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M116.48 92.928H119.68"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.9104 104.96C95.9104 106.24 81.8304 107.392 64.3328 107.392C46.8352 107.392 32.768 106.304 32.768 104.96C32.768 103.616 46.848 102.528 64.3328 102.528C81.8176 102.528 95.9104 103.68 95.9104 104.96Z"
        fill="#F5F4F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.3338 55.6669H86.6672C91.0854 55.6669 94.6672 59.2486 94.6672 63.6669V85.0002C94.6672 86.473 93.4733 87.6669 92.0005 87.6669H49.3338"
        fill="#B56DC6"
      />
      <path
        d="M41.3338 55.6669H86.6672C91.0854 55.6669 94.6672 59.2486 94.6672 63.6669V85.0002C94.6672 86.473 93.4733 87.6669 92.0005 87.6669H49.3338"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.3338 87.6669H36.0005C34.5277 87.6669 33.3338 86.473 33.3338 85.0002V63.6669C33.3338 59.2486 36.9156 55.6669 41.3338 55.6669C45.7521 55.6669 49.3338 59.2486 49.3338 63.6669V87.6669Z"
        fill="#FDF5FF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M68 87.6669V103.667" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M62.6677 87.6669V103.667"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M68.001 103.667C68.0008 105 62.6679 105 62.6677 103.667C62.6675 102.334 62.6677 87.6669 62.6677 87.6669H68.001C68.001 87.6669 68.0012 102.334 68.001 103.667Z"
        fill="#FDF5FF"
        stroke="#6A266D"
      />
      <path
        d="M38.6677 82.3338H44.001"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.6677 61L62.6677 61L54.6677 61Z"
        fill="#E6FBFF"
      />
      <path
        d="M54.6677 61L62.6677 61"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68 61L68 69L62.6667 69L62.6667 61L68 61Z"
        fill="#FDF5FF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M96.3762 72.0271L100.384 68.8678L104.068 73.5418L100.061 76.7011L96.3762 72.0271Z"
      fill="white"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M111.559 82.1568C112.14 82.8633 112.42 83.75 112.337 84.6221C112.254 85.4941 111.815 86.2799 111.116 86.8066C110.418 87.3333 109.517 87.5579 108.612 87.4307C107.707 87.3036 106.872 86.8353 106.291 86.1288L99.7186 78.1366C99.5735 77.9599 99.5037 77.7382 99.5245 77.5202C99.5453 77.3022 99.655 77.1057 99.8295 76.9739L103.78 73.995C103.955 73.8634 104.18 73.8074 104.406 73.8392C104.633 73.871 104.841 73.988 104.987 74.1645L111.559 82.1568Z"
      fill="#B56DC6"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M75 49.8564C73.9494 51.6761 73.2675 53.6848 72.9933 55.768C72.719 57.8512 72.8578 59.968 73.4016 61.9975C73.9454 64.0271 74.8837 65.9296 76.1628 67.5966C77.4419 69.2635 79.0368 70.6622 80.8564 71.7128C82.6761 72.7634 84.6848 73.4453 86.768 73.7195C88.8512 73.9938 90.968 73.855 92.9975 73.3112C95.0271 72.7674 96.9296 71.8292 98.5966 70.5501C100.264 69.271 101.662 67.6761 102.713 65.8564C103.763 64.0368 104.445 62.028 104.72 59.9448C104.994 57.8617 104.855 55.7449 104.311 53.7153C103.767 51.6857 102.829 49.7832 101.55 48.1162C100.271 46.4493 98.6761 45.0506 96.8564 44C95.0368 42.9494 93.028 42.2675 90.9448 41.9933C88.8616 41.719 86.7449 41.8578 84.7153 42.4016C82.6857 42.9454 80.7832 43.8837 79.1162 45.1628C77.4493 46.4419 76.0506 48.0368 75 49.8564Z"
      fill="white"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M76.4573 53.3269C75.2524 56.5962 75.3955 60.2101 76.8548 63.3736C78.3142 66.5371 80.9704 68.9911 84.2391 70.1957C87.5078 71.4003 91.1212 71.2568 94.2844 69.7968C97.4477 68.3369 99.9016 65.68 101.106 62.4107C102.311 59.1414 102.168 55.5275 100.709 52.364C99.2495 49.2005 96.5933 46.7465 93.3246 45.5419C90.0559 44.3373 86.4425 44.4808 83.2793 45.9408C80.116 47.4007 77.6621 50.0576 76.4573 53.3269Z"
      fill="#E6FBFF"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
